<template>
 <section class="pay">
   <header-com isTransparent/>

   <!--选择地址-->
   <select-add/>

   <!--内容区-->
   <div class="contentWrap">
	 <!--商品详情-->
	 <div class="proInfo">
	   <pro-info-com  v-if="proDetail.id" :item="proDetail">
		 <p class="f24 price"><span >¥</span><span class="f48 bold">{{proDetail.price}}</span>
		   <i class="grey9" v-if="proDetail.originalPrice">￥{{proDetail.originalPrice}}</i></p>
	   </pro-info-com>

	 </div>

	 <!--无忧购服务列表-->
	 <service-com v-if="orderType === orderTypeObj.buy" @checkService="checkService"></service-com>

	 <!--换背-->
	 <!--productState 10正在背   20已退回  30已买断 40服务已过期-->
	 <div class="changeBag" v-if="orderType === orderTypeObj.change && currentBagDetail.product.productState === 10">
	   <section class="container ">
		 <h2>选择当前在背包包的处置方式 <span class="subTitle"  @click="$showStandardPopup">了解详情</span></h2>

		 <!--在背中需要换背的商品 选择处置方式-->
		 <ul class="f28 wayList">
		   <li :class="isBuyout?'':'active'" @click="isBuyout=false"><span></span><i>换背，请于新包付款后7日内寄回</i></li>
		   <li :class="isBuyout?'active':''" @click="isBuyout=true"><span></span><i>直接购买（买断不占用换背次数）</i></li>
		 </ul>
		 <!-- 在背包详情 -->
		 <div class="changeBagDetail ">
		   <span class="changeTag"></span>
		   <img class="l" :src="currentBagDetail.product.baseProductPics[0] | formatImgUrl(200,200,true) " align="middle">
		   <h3 class="f28 twoClamp">{{currentBagDetail.product.brandNameEn}}<br>{{currentBagDetail.product.name+' '+ currentBagDetail.product.categoryName}}</h3>
		   <p class="f28 price"><span >¥</span><span class="f48 bold">{{currentBagDetail.product.price}}</span></p>
		 </div>
	   </section>
	 </div>


	 <section class="container paymentDetails">
	   <h2>支付明细</h2>
	   <h3  v-if="orderType === orderTypeObj.buy && preOrderDetail.couponUserDTO"
			@click="$refs['couponPopup'].show()">
		 <span  class="bold f30"></span>优惠券 <div class="r coupon f26">{{preOrderDetail.couponUserDTO.couponDto.name}}</div>
	   </h3>
	   <ul class="f28">
		 <li v-for="(item,index) in preOrderDetail.payDetailDTOList" :key="index">
		   <div class="left  ">
			 <i class="f20 grey9">·······························································································································································</i>
			 <span>{{item.key}}</span>
		   </div>
		   <div class="right f32 bold ">{{item.value}}</div>
		 </li>
		 <p v-if="orderType === orderTypeObj.change" class="f22 grey9">注：退回前包，鉴定通过后即按原路全额退前包金额</p>
	   </ul>
	 </section>


	 <section class="rules" v-if="orderType === orderTypeObj.buy">
	   <!--<h2>买家承诺</h2>-->
	   <radio :checked="isAgree" @toggleRadio="isAgree = !isAgree">同意<i @click="$showServiceProtocolPopup">《陈真退换保障服务协议》</i></radio>
	 </section>
   </div>


   <bottom-tip v-if="orderType === orderTypeObj.change"></bottom-tip>
   <div class="g-fixed-bottom">
	 <div class="f28">RMB：<span class="f36 bold">{{preOrderDetail.payAmount}}</span></div>
	 <button class="primary" @click="submitOrder" >提交订单</button>
   </div>


   <!--优惠券弹窗-->
   <my-popup ref="couponPopup" height="350px" class="couponPopup">
	 <!--<div class="closeBtn f28" @click="isShowCouponPopup = false">取消</div>-->
	 <ul class="couponList">
	   <li  v-for="(item,index) in couponList"
			:key="index" @click="checkCoupon(item)">
		 <radio :checked="params.couponUserId === item.id" ></radio>
		 <coupon-item-com :item="item"></coupon-item-com>
	   </li>
	 </ul>
   </my-popup>
   <!--支付弹窗-->
   <pay-type-popup ref="payTypePopup"
				   @selectPayType="confirmOrder"></pay-type-popup>
 </section>
</template>

<script>
  import payApi from '@api/pay'
  import myApi from '@api/my'
  import orderApi from '@api/order'
  import payObj from '@utils/pay'
  import publicObj from '@utils/public'
  import { mapState } from 'vuex'
  import MyPopup from "../../../components/myPopup";
  import BottomTip from "../../../components/bottomTip";
  export default {
    name: 'pay',
    components: {BottomTip, MyPopup},
    data() {
      return {
				payType:this.$route.query.orderType || '',
        isAgree:true,
        // isShowCouponPopup:false,
        couponList:[],
		proDetail:{},
		preOrderDetail:{
          couponUserDTO:{
            couponDto:{}
		  },
		},
        currentBagDetail:{
          product:{
            baseProductPics:['']
		  }
		},
		// 是否买断
		isBuyout:false,
		serviceList:[],
		params:{
          sku:this.$route.query.id,
          couponUserId:'',
		  // 换背时用户选择的服务id
          // userServiceId:'',
		  // 无忧购时 选择的服务id
          serviceItemId:''
		},
		//0->正常使用；1->已退回；2->已买断；3->已取消
		stateObj:{
          0:'正在背',
          1:'已退回',
          2:'已买断',
		},
		// isSubmit:false
	  }
    },
    watch: {},
    computed: {
      ...mapState({
        orderTypeObj:'orderTypeObj',
        serviceObj:'serviceObj',
        selectAddObj: state => state.user.selectAddObj
      }),
      orderType(){
        // 1购买 2换背
        return this.$route.query.orderType || ''
	  },

	},
    created() {
      this.getProDetail();
      switch (this.orderType) {
		case this.orderTypeObj.buy:
          //无忧购 获取优惠券列表
          // this.getCouponList();
		  break;
        case this.orderTypeObj.change:
          //换背
          // this.getUserServiceList();
          this.getPayDetails();
          this.getCurrentBag();
          break;
        case this.orderTypeObj.directBuy:
          // 直接购买
          this.getPayDetails();
          break;
      }
    },
    mounted() {
    },
    methods: {
      // 获取下单页商品详情
      getProDetail(){
        payApi.getProDetail({
          sku:this.params.sku,
        }).then(res =>{
          this.proDetail =res;
        }).catch(res=>{
          if(res.code === 10001 || res.code === 10002 ||res.code === 10003 ){
            setTimeout(()=>{
              this.$router.back()
            },2000)
          }
        })
	  },

	  //获取订单支付明细
      getPayDetails(){
        payApi.getPayDetails({
		  ...this.params,
          orderType:this.orderType,
        }).then(res =>{
          this.preOrderDetail =res;
		  if(this.orderType === this.orderTypeObj.buy){
			this.params.couponUserId =res.couponUserDTO.id;
		  }
        }).catch(() => {})
	  },
	  // 无忧购选择服务
		checkService(serviceItemId) {
			this.params.serviceItemId = serviceItemId;
			this.params.couponUserId = ''
			this.getCouponList();
			this.getPayDetails();
		},
	  // 获取当前正在背的包
	  getCurrentBag(){
		payApi.getCurrentBag().then(res=>{
		  this.currentBagDetail = res;
		  // console.log(res)
		})
	  },

      // // 获取用户服务列表
      // getUserServiceList(){
      //   // 只展示有效服务
      //   myApi.getUserServiceList({
      //     isEffective:1
      //   }).then(res=>{
      //     this.serviceList = res;
      //     this.params.userServiceId = res[0].id
      //   })
      // },
      // 获取优惠券列表
		getCouponList() {
			myApi.getOrderCouponsList({
				pageSize: 100,
				useState: 0,
				serviceItemId: this.params.serviceItemId
			}).then(res => {
				this.couponList = res.result;
			})
		},
	  //选择优惠券
	  checkCoupon(item){
        this.params.couponUserId = item.id;
        this.getPayDetails();
		this.$refs['couponPopup'].hide()
	  },
	  // 提交订单
      submitOrder(){
				//诸葛：购买流程
					let proDetail=this.proDetail
					let zhugeName=this.orderType!==this.orderTypeObj.directBuy?"换背-点击提交订单":"购买-点击提交订单"
          zhuge.track(zhugeName, {
            "商品名称":proDetail.brandNameEn+' '+proDetail.name+' '+proDetail.categoryName,
            "品牌":proDetail.brandNameEn,
            "价格":proDetail.price,
            "商品等级":proDetail.attributes[0].value
          });
        if(!this.selectAddObj.id){
          this.$toast('请选择地址');
		  return
		}

        // 无忧购状态下需要展示协议
        if(!this.isAgree && this.orderType === this.orderTypeObj.buy){
          this.$toast('请阅读协议并同意');
          return
        }

		if(publicObj.isWeiXin()){
		  //微信内支付
		  this.confirmOrder()
		}else {
		  //微信外支付 展示弹窗选择
		  this.$refs['payTypePopup'].show()
		}


	  },
	  // 确认订单
	  confirmOrder(payType){
        let params = {
          userAddressId:this.selectAddObj.id,
          orderType:this.orderType,
          ...this.params,
		};
        if(this.isBuyout){
          //选择买断
          orderApi.confirmBuyOut(this.currentBagDetail.id).then(res => {})
		}

        // console.log(params)
		// return
        //创建订单
        payApi.createOrder(params).then(res => {
          const orderCode = res.orderCode;
          //根据订单号获取支付参数
          const  payParams = payObj.getPayParams({
            payType:payType,
            orderCode:orderCode,
						backType: payObj.backTypeObj.product,
						orderType:this.orderType
				});

			//诸葛：点击确认支付
			let zhugeName = this.orderType !== this.orderTypeObj.directBuy ? "换背-点击确认支付" : "购买-点击确认支付"
			zhuge.track(zhugeName, {
				"支付时间": publicObj.formatDate(Date.now(), "YY-MM-DD hh:mm:ss"),
				"支付方式": payType?payType === 1 ? "微信支付" : "支付宝支付" : "微信支付",
				"订单id": orderCode
			});

          payObj.isWeiXinApp(payParams.clientType,{
            orderCode:orderCode
		  }).then(message=>{
            // 立即支付
            payApi.payByOrderCode({
              orderCode:orderCode,
              ...payParams
            }).then(res => {
              payObj.confirmPay(payParams.clientType,res,this.orderType);
            })
		  })

        }).catch(res=>{
          if(res.code === 10001 || res.code === 10002 ||res.code === 10003 ){
            // 商品缺货或下架
            setTimeout(()=>{
              this.$router.back()
            },2000)
          }else if(res.code === 20001 || res.code === 20002){
            // 有待支付、未收货的商品
            setTimeout(()=>{
              this.$router.replace({name:'purchaseOrder'})
            },2000)
		  }
		})
      }
	}
  }
</script>

<style lang="scss" scoped>
.pay{
  padding:  84px 0 180px;
  .tips{
	height: 68px;
	padding: 24px 60px 24px 104px;
	background: $primary-color;
	color: $white-color;
	line-height: 34px;
	 letter-spacing: -.5px;
  }
  .contentWrap{
	padding: 48px 40px 0;

	/*无忧购*/
	.proInfo{
	  .proInfoCom{
		/*margin-bottom: 30px;*/
	  }
	  .price{
		height: 66px;
		line-height: 66px;
		i{
		  text-decoration: line-through;
		  margin-left: 30px;
		}
	  }
	}

	/*换背*/
	.changeBag{
	  .wayList li{
		margin-bottom: 32px;
		span,i{
		  vertical-align: middle;
		}
		span{
		  display: inline-block;
		  width: 32px;
		  height: 32px;
		  margin-right: 18px;
		  border:2px solid #E7E7E7;
		  position: relative;
		  border-radius: 50%;
		  &::after{
			content: "";
			width: 24px;
			height: 24px;
			border-radius: 50%;
			background: #E7E7E7;
			position: absolute;
			left: 50%;
			top:50%;
			transform: translate(-50%,-50%);
		  }
		}
		&.active span{
		  border-color: $brand-color;
		  &:after{
			background: $brand-color;
		  }
		}

	  }
	  .changeBagDetail{
		padding: 20px;
		border: 1px #e9e9e9 solid;
		line-height: 40px;
		border-radius: $base-radius;
		margin-bottom: 32px;
		position: relative;
		.changeTag{
		  position: absolute;
		  left: 20px;
		  top: 0;
		}
		img{
		  width: 142px;
		  height: 142px;
		  margin-right: 44px;
		}
		h3{
		  padding: 12px 0 18px;
		}
	  }
	}

	.container{
	  /*padding: 80px 0 40px;*/
	  border-bottom: $light-border;
	  h2{
		font-size: 32px;
		padding: 48px 0;
		line-height: 36px;
		font-weight: bold;
		/*margin-bottom: 50px;*/
	  }
	}


	/*支付明细*/
	.paymentDetails{
	  h3{
		line-height: 42px;
		padding-left: 68px;
		margin-bottom: 78px;
		background: url("/images/pay/coupon_icon.png") no-repeat left center;
		background-size: 40px;
		.coupon{
		  padding-right: 28px;
		  background:url("/images/base/arrow_right.png") no-repeat right 11px;
		  background-size: 10px;
		}
	  }
	  ul{
		padding-left: 100px;
		margin-bottom: 48px;
		li{
		  line-height: 44px;
		  margin-bottom: 36px;
		  display: flex;
		  justify-content: space-between;
		  .left{
			width: 430px;
			overflow: hidden;
			position: relative;
			span{
			  position: absolute;
			  padding-right: 12px;
			  left: 0;
			  top:0;
			  background: $white-color;
			}
		  }
		  .price{
			width: 150px;
		  }
		}
	  }
	  p{margin-top:-22px }
	}
  }

  .rules{
	padding: 40px 0 ;
	i{color: $brand-color}
  }

  .g-fixed-bottom{
	display: flex;
	justify-content: space-between;
	div{
	  line-height: 86px;
	}
  }

  /*优惠券弹窗*/
  .couponPopup{
	.couponList{
	  padding: 100px 20px 40px;
	  max-height: 700px;
	  li{
		position: relative;
	  }
	  .radio{
		position: absolute;
		right: 30px;
		top:50px
	  }
	}
	/*.closeBtn{*/
	  /*position: absolute;*/
	  /*right: 40px;*/
	  /*top:32px;*/
	  /*line-height: 40px;*/
	  /*z-index: 10;*/
	/*}*/
  }

}
</style>
